// Generated by scripts/capture_landing_screenshots.mjs - do not edit by hand.
export const TOUR_SHOTS_VERSION = "0bd00831";
